import { ProductSizeProps, SizeProps } from "../../../Locator/types";
const getProductsInStore = ({ storeSizes, allProductSizes }) => allProductSizes === null || allProductSizes === void 0 ? void 0 : allProductSizes.reduce((sizesInformation, productSize) => {
    const storeSize = storeSizes && storeSizes.find(({ sizeCode }) => productSize.sizeCode === sizeCode);
    if (storeSize) {
        return [
            ...sizesInformation,
            Object.assign(Object.assign({}, productSize), { traffLightInd: storeSize.traffLightInd, avaiQty: storeSize.avaiQty }),
        ];
    }
    return sizesInformation;
}, []);
const getOutOfStockAndInStoreData = (storeData, allProductSizes) => {
    const storeSizes = storeData;
    const productsInStore = getProductsInStore({ storeSizes, allProductSizes });
    return {
        isOutOfStock: (productsInStore === null || productsInStore === void 0 ? void 0 : productsInStore.filter((product) => product.avaiQty && product.avaiQty > 0 && product.traffLightInd !== 'R').length) === 0,
        isInStock: productsInStore === null || productsInStore === void 0 ? void 0 : productsInStore.filter((product) => product.avaiQty && product.avaiQty > 0 && product.traffLightInd !== 'R'),
        productsInStore,
    };
};
export default getOutOfStockAndInStoreData;
//# sourceMappingURL=getOutOfStockAndInStoreData.js.map